<template>
  <div class="BulkOrderbysea">
    <h4>{{ $t("i18n_FBA_order") }}</h4>
    <el-form
      ref="OrderQueryConditions"
      :label-position="labelPosition"
      :model="OrderQueryConditions"
    >
      <el-form-item :label="$t('i18n_Tracking_number')">
        <el-input
          v-model="OrderQueryConditions.OrderCode"
          :placeholder="$t('i18n_please_enter')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('i18n_PO_number')">
        <el-input
          v-model="OrderQueryConditions.pro"
          :placeholder="$t('i18n_please_enter')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('i18n_Clients_tracking_number')">
        <el-input
          v-model="OrderQueryConditions.customerNo"
          :placeholder="$t('i18n_please_enter')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('i18n_receving_warehosue')">
        <el-cascader
          clearable
          style="width: 200px"
          :placeholder="$t('i18n_Please_choose_original_wareohuse')"
          v-model="thatALLcklist"
          :options="FBAfromCk"
          :props="FBAdataprops"
          ref="changefromFABck"
          @change="changefromFABck(thatALLcklist)"
        >
        </el-cascader>
      </el-form-item>
      <el-form-item :label="$t('i18n_destination')">
        <el-cascader
          clearable
          :placeholder="$t('i18n_please_choose_your_destination')"
          style="width: 200px"
          ref="changetoFABck"
          v-model="thatFBAcklist"
          :options="FBAtoCk"
          :props="toFBAdataprops"
          @change="changetoFABck(thatFBAcklist)"
        >
          <template slot-scope="{ node, data }">
            <span>{{ data.namec }}</span>
            <span v-if="!node.isLeaf"></span>
          </template>
        </el-cascader>
      </el-form-item>
      <el-form-item :label="$t('i18n_shipment_arrival_time')">
        <el-date-picker
          v-model="OrderQueryConditions.inHouseData"
          type="daterange"
          value-format="yyyy-MM-dd"
          clearable
          range-separator="-"
          :start-placeholder="$t('i18n_started_date')"
          :end-placeholder="$t('i18n_end_date')"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item style="width: 350px" :label="$t('i18n_Order_date')">
        <el-date-picker
          v-model="OrderQueryConditions.EntrustmentData"
          type="daterange"
          clearable
          value-format="yyyy-MM-dd"
          range-separator="-"
          :start-placeholder="$t('i18n_started_date')"
          :end-placeholder="$t('i18n_end_date')"
        >
        </el-date-picker>
      </el-form-item>
      <el-button type="primary" style="margin-left: 30px" @click="onSubmit">{{
        $t("i18n_Inquiry")
      }}</el-button>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
      <el-tab-pane
        :label="$t(item.staus_desc)"
        :name="item.order_status"
        v-for="(item, key) in tabsList"
        :key="key"
      >
        <el-table
          border
          align="center"
          :data="tableData"
          max-height="580"
          tooltip-effect="dark"
          :header-cell-style="{ background: '#F3F3F3' }"
          ref="multipleTable"
          style="width: 95%; margin-left: 32px"
        >
          <!-- <el-table-column type="selection" label="全选" min-width="5%"></el-table-column> -->
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->

          <el-table-column
            type="index"
            :label="$t('i18n_Serial_number')"
            width="70px"
          ></el-table-column>
          <el-table-column
            prop="nos"
            :label="$t('i18n_Tracking_number')"
            show-overflow-tooltip
            width="200px"
          ></el-table-column>
          <el-table-column
            prop="pro"
            :label="$t('i18n_PO_number')"
            show-overflow-tooltip
            width="180px"
          ></el-table-column>
          <el-table-column
            prop="customerNo"
            :label="$t('i18n_Clients_tracking_number')"
            show-overflow-tooltip
            width="180px"
          ></el-table-column>
          <el-table-column
            prop="warehousename"
            :label="$t('i18n_receving_warehosue')"
            show-overflow-tooltip
            width="150px"
          ></el-table-column>
          <el-table-column
            prop="recgoodscountry"
            :label="$t('i18n_destined_country')"
            show-overflow-tooltip
            width="100px"
          ></el-table-column>
          <el-table-column
            prop="recgoodsname"
            :label="$t('i18n_destination')"
            width="140px"
            show-overflow-tooltip
          ></el-table-column>

          <el-table-column
            prop=""
            :label="$t('i18n_shipment_information')"
            show-overflow-tooltip
            width="200px"
          >
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.beforeGoodsList.length"
                trigger="hover"
                placement="top"
              >
                <div style="text-align: center">
                  <div
                    v-for="(item, index) in scope.row.beforeGoodsList"
                    :key="index"
                  >
                    {{ item.goodstype }}* {{ item.number }} {{ item.cbm }}CBM
                    {{ item.weight }}KG
                  </div>
                </div>
                <div slot="reference" class="name-wrapper">
                  {{ scope.row.beforeGoodsList[0].goodstype }}*
                  {{ scope.row.beforeGoodsList[0].number }}
                  {{ scope.row.beforeGoodsList[0].cbm }}CBM
                  {{ scope.row.beforeGoodsList[0].weight }}KG
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            :label="$t('i18n_Accurated_package_info')"
            show-overflow-tooltip
            width="200px"
          >
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.goodsList.length"
                trigger="hover"
                placement="top"
              >
                <div style="text-align: center">
                  <div
                    v-for="(item, index) in scope.row.goodsList"
                    :key="index"
                  >
                    {{ item.goodstype }}* {{ item.number }} {{ item.cbm }}CBM
                    {{ item.weight }}KG
                  </div>
                </div>
                <div slot="reference" class="name-wrapper">
                  {{ scope.row.goodsList[0].goodstype }}*
                  {{ scope.row.goodsList[0].number }}
                  {{ scope.row.goodsList[0].cbm }}CBM
                  {{ scope.row.goodsList[0].weight }}KG
                </div>
              </el-popover>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            :label="$t('i18n_estimated_cost')"
            show-overflow-tooltip
            width="120px"
          >
            <template slot-scope="scope">
              {{
                scope.row.costbeforeinfo.amount1
                  ? scope.row.costbeforeinfo.amount1
                  : 0.0
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            :label="$t('i18n_destined_isChoseSafe')"
            show-overflow-tooltip
            width="100px"
          >
            <template slot-scope="scope">
              <span style="width: 100%; text-align: center">
                {{ scope.row.checkInsurance ? "是" : "否" }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            :label="$t('i18n_actual_cost')"
            show-overflow-tooltip
            width="120px"
          >
            <template slot-scope="scope">
              {{
                scope.row.costinfo.amount2 != "0.00"
                  ? scope.row.costinfo.amount2
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            :label="$t('i18n_Tracking')"
            show-overflow-tooltip
            width="240px"
          ></el-table-column>
          <!-- <el-table-column prop="job_status" label="状态" min-width="10%"></el-table-column> -->
          <el-table-column
            prop="operation"
            :label="$t('i18n_Operation')"
            width="120px"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-dropdown>
                <span style="cursor: pointer" class="el-dropdown-link">
                  {{ $t("i18n_Operation")
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu
                  slot="dropdown"
                  style="box-sizing: border-box; padding: 6px; padding-top: 0px"
                >
                  <el-dropdown-item
                    style="
                      width: 62px;
                      height: 32px;
                      line-height: 32px;
                      background: #409eff;
                      color: #fff;
                      border-radius: 5px;
                      text-align: center;
                      padding: 0px 6px;
                      margin-top: 6px;
                    "
                  >
                    <span @click="orderdetails(scope)">{{
                      $t("i18n_view_details")
                    }}</span></el-dropdown-item
                  >
                  <el-dropdown-item
                    style="
                      width: 62px;
                      height: 32px;
                      line-height: 32px;
                      background: #67c23a;
                      color: #fff;
                      border-radius: 5px;
                      text-align: center;
                      margin-top: 6px;
                      padding: 0px 6px;
                    "
                    ><span @click="downLoadLabel(scope.row)">{{
                      $t("i18n_download_labels")
                    }}</span></el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    style="
                      width: 62px;
                      height: 32px;
                      line-height: 32px;
                      background: #f56c6c;
                      color: #fff;
                      border-radius: 5px;
                      text-align: center;
                      margin-top: 6px;
                      padding: 0px 6px;
                    "
                    ><span @click="disableOrder(scope.row)">{{
                      $t("i18n_Cancel")
                    }}</span></el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="scope.row.state == 3"
                    style="
                      width: 62px;
                      height: 32px;
                      line-height: 32px;
                      background: #f56c6c;
                      color: #fff;
                      border-radius: 5px;
                      text-align: center;
                      margin-top: 6px;
                      padding: 0px 6px;
                    "
                  >
                    <span @click="deleteOrder(scope.row)">{{
                      $t("i18n_delete")
                    }}</span></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-button @click="orderdetails(scope)" type="text" size="small"
                >查看详情</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <div style="">
      <el-pagination
        style="margin: 20px; margin-left: 32px; float: left"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="curPageL"
        :pager-count="5"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import fileDownload from 'js-file-download'
export default {
  name: "BulkOrderbysea",
  data() {
    return {
      thatFBAcklist: [],
      FBAdataprops: {
        //定义 联级选择器的国家和区域获取name
        label: "namec",
        value: "id",
        children: "datWarehouseDTOList",
      },
      toFBAdataprops: {
        label: "namec",
        value: "id",
        children: "children",
      },
      thatALLcklist: [], //入仓仓库
      FBAfromCk: [],
      FBAtoCk: [],
      total: 0, //总条数
      pagesize: 10, //每页显示条数
      prefix: "",
      labelPosition: "left",
      activeName: "Z",
      tabsList: [],

      OrderQueryConditions: {
        //表单
        OrderCode: "", //运单号
        pro: "", //PO号
        InwareHouse: "", //入仓仓库
        DestinationCountry: "", //目的国家
        DistributionArea: "", //配送区域
        EntrustmentData: [], //委托日期
        inHouseData: [], //入仓时间
      },
      tableData: [],
      customerid: "", //运单号
      typeCode: "Z", //查询类型
      curPageL: 1,
      warehouseList: [], //仓库列表
      territoryList: [], //目的国家id列表
      distributionList: [], //配送目的列表
    };
  },
  watch: {},
  methods: {
    // 作废订单
    disableOrder(item) {
      // console.log(item);
      // 校验原因必填
      let validator = (v) => (v ? true : false);
      this.$prompt("请输入作废原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValidator: validator,
        inputErrorMessage: "必填项",
      })
        .then(({ value }) => {
          this.axios
            .get(`/busFbx/invalidFbxOrder/${item.nos}/${value}`)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.info("作废成功");
                this.onSubmit()//重新刷新获取列表
              } else {
                this.$message.info(res.data.message);
              }
            })
            .catch((res) => {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消",
          });
        });
    },
    // 删除订单
    deleteOrder(item) {

      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {

          this.axios.get(`/busFbx/deleteFbxInvalidOrder/${item.nos}`)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.info("删除成功");
              } else {
                this.$message.info(res.data.message);
              }
            }).catch((res) => {
              console.log(res);
            });

        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });

    },

    // 下载标签
    downLoadLabel(row) {
      this.axios
        .get(`/busFbx/downFBXOrderLabel/${row.nos}`)
        .then((res) => {
          if (res.data.code == 200) {
            console.log();
            let a = document.createElement("a");
            a.setAttribute("href", res.data.data);
            a.setAttribute("target", "_blank");
            a.click();
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
      // this.axios({
      //   method: 'get',
      //   url: `/busFbx/downFBXOrderLabelNew/${row.nos}`,
      //   responseType: 'blob'
      // }).then((res) => {
      //   if (res) {
      //     fileDownload(res.data, `订单标签${row.nos}.pdf`)
      //     this.$message.success('下载成功!')
      //   }
      // })
      // .catch((err) => {
      //   console.log(err)
      // })
    },
    changefromFABck(list) {
      console.log(list[1]);
      this.OrderQueryConditions.InwareHouse = list[1];
    },
    changetoFABck(list) {
      console.log(list);
      this.OrderQueryConditions.DestinationCountry = list[2];
    },
    getFBAtoCk() {
      //获取fba仓库
      this.axios
        .get("/warehouse/getFBAWarehouseList")
        .then((res) => {
          console.log(res);
          this.FBAtoCk = res.data.datas;
        })
        .catch((res) => { });
    },
    getFBAfromCk() {
      //获取fba起运地仓库
      this.axios
        .get("/warehouse/getAllWarehouseList")
        .then((res) => {
          this.FBAfromCk = res.data.datas;
        })
        .catch((res) => { });
    },
    orderdetails(data) {
      //查看详情点击
      this.$router.push({
        name: "FbaOrderDetails",
        query: { state: data.row.state, nos: data.row.nos },
      });
    },
    onSubmit() {
      //点击查询方法
      this.curPageL = 1;
      this.getAllOrder();
    },
    handleClick(activeName) {
      //tabs标签切换
      this.typeCode = activeName;
      this.getAllOrder(); //切换tabs
    },
    handleSizeChange(val) {
      //分页每页多少条
      this.pagesize = val;

      this.getAllOrder();
    },
    handleCurrentChange(val) {
      //分页当前页
      this.curPageL = val;

      this.getAllOrder();
    },
    warehouse() {
      //仓库id获取
      this.axios
        .get("/warehouse/warehouseListAll")
        .then((response) => {
          this.warehouseList = response.data.datas;
          let newda = {
            namec: "全部",
            id: "",
          };
          this.warehouseList.splice(0, 0, newda);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    territory() {
      //目的国家以及配送区域的id获取
      this.axios
        .get("/filedata/filedataListAll")
        .then((response) => {
          this.territoryList = response.data.datas;
          this.distributionList = this.territoryList[0].children;
          // console.log(this.distributionList);
          let newda = {
            namec: "全部",
            id: "",
          };
          this.territoryList.splice(0, 0, newda);
          this.distributionList.splice(0, 0, newda);
          this.OrderQueryConditions.DistributionArea = this.distributionList[0].namec;
          // console.log(this.OrderQueryConditions.DistributionArea);//
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    changMC(item) {
      //切换目的国家，配送区域二级联动
      // console.log(item);
      for (var i = 0; i < this.territoryList.length; i++) {
        if (this.territoryList[i].id == item) {
          this.distributionList = this.territoryList[i].children;
          this.OrderQueryConditions.DistributionArea = this.territoryList[
            i
          ].children[0].namec;
        }
      }
      let newda = {
        namec: "全部",
      };
      this.distributionList.splice(0, 0, newda);
      this.OrderQueryConditions.DistributionArea = this.distributionList[0].namec;
    },
    getAllOrder() {
      //获取全部订单
      if (this.OrderQueryConditions.DistributionArea == "全部") {
        this.OrderQueryConditions.DistributionArea = "";
      }
      if (this.OrderQueryConditions.EntrustmentData == null) {
        this.OrderQueryConditions.EntrustmentData = ["", ""];
      }
      if (this.OrderQueryConditions.EntrustmentData == null) {
        this.OrderQueryConditions.EntrustmentData = [];
      }
      if (this.OrderQueryConditions.inHouseData == null) {
        this.OrderQueryConditions.inHouseData = [];
      }
      let data = {
        customerNo: this.OrderQueryConditions.customerNo, // 客户单号
        beginTime: this.OrderQueryConditions.inHouseData[0] || "", //入仓开始时间
        endTime: this.OrderQueryConditions.inHouseData[1] || "", //入仓结束时间
        towarehouseid: this.OrderQueryConditions.DestinationCountry, //国家id
        curPage: this.curPageL, //当前页，默认1
        customerid: this.customerid, //客户id

        language: "CN",
        nos: this.OrderQueryConditions.OrderCode, //运单号
        pro: this.OrderQueryConditions.pro, //运单号
        pageSize: this.pagesize, //每页数量，默认20
        type: this.typeCode, //运单状态类型
        warehouseid: this.OrderQueryConditions.InwareHouse, //仓库id
        inputTime: this.OrderQueryConditions.EntrustmentData[0] || "", //委托日期
        endputTime: this.OrderQueryConditions.EntrustmentData[1] || "",
      };
      // console.log(data);
      let that = this;
      that.axios
        .post("/busFbx/getFbxJobsHistoryWebList", data)
        .then((res) => {
          console.log(this.tableData);
          if (res.data.code == 200 && res.data.data.orderList.length) {
            console.log(res.data.data.orderList);
            this.tableData = res.data.data.orderList;
          } else {
            this.tableData = [];
            this.$message(this.$t('i18n_No_data'))
          }
          that.total = Number(res.data.data.totalCounts);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getPansonageOrder() {
      //获取个人表头信息
      let data = {
        customerid: this.customerid,
        jobtype: "C",
        language: "CN",
      };
      this.axios
        .get("/busFbx/getFBXJobStatusCount/" + this.customerid)
        .then((response) => {
          let datas = response.data.data.statusList;
          this.tabsList = [];
          for (var i = 0; i < datas.length; i++) {
            this.tabsList.push(datas[i]);
            this.tabsList[i].staus_desc =
              datas[i].staus_desc + "(" + datas[i].counts + ")";
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  created() {
    let publics = JSON.parse(sessionStorage.getItem("Authorization"));
    this.customerid = publics.customerid;
  },
  mounted() {
    this.getAllOrder();
    this.warehouse();
    this.territory();
    this.getPansonageOrder();
    this.getFBAfromCk();
    this.getFBAtoCk();
  },
};
</script>
<style scoped>
.el-table >>> th.gutter {
  display: table-cell !important;
}
.el-table th.gutter {
  display: table-cell !important;
}
.BulkOrderbysea {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}
.BulkOrderbysea h4 {
  font-size: 24px;
  font-family: "PingFang-SC-Bold";
  color: #343434;
  padding-left: 32px;
  padding-top: 32px;
}
/* .BulkOrderbysea h4 {
  width: 100%;
  height: 24px;
  padding-top: 30px;
  padding-left: 31px;
  font-size: 24px;
  font-family: "PingFang-SC-Bold";
  color: #343434;
} */
.BulkOrderbysea footer {
  width: 100%;
  height: 35px;
  margin-top: 10px;
  position: relative;
  box-sizing: border-box;
}
.BulkOrderbysea .el-form {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 32px;
  row-gap: 12px;
  padding-left: 32px;
}
.BulkOrderbysea .el-form-item {
  display: flex;
  height: 32px;
  margin: 0;
}
.BulkOrderbysea >>> .el-input__inner {
  width: 217px;
  height: 32px !important;
  line-height: 32px;
}

.BulkOrderbysea >>> .el-pagination {
  display: flex;
  align-items: center;
  height: 32px;
  padding: 0px;
}

.BulkOrderbysea >>> .el-pagination .el-input__inner {
  width: 100px;
  height: 32px !important;
  line-height: 32px;
}
.BulkOrderbysea >>> .el-pagination__jump {
  height: 32px;
  line-height: 32px;
}

.BulkOrderbysea >>> .is-in-pagination .el-input__inner {
  width: 44px;
}

.BulkOrderbysea >>> .el-form-item__content {
  line-height: 32px;
}

.BulkOrderbysea >>> .el-input__icon {
  line-height: 32px;
}

.BulkOrderbysea >>> .el-cascader {
  line-height: 32px;
}

.BulkOrderbysea >>> .el-form-item__label {
  height: 32px;
  line-height: 32px;
}

.BulkOrderbysea >>> .el-button {
  box-sizing: border-box;
  height: 32px;
  line-height: 32px;
  margin: 0;
  padding: 0;
  width: 72px;
}

.BulkOrderbysea >>> .el-date-editor {
  width: 262px;
  height: 32px !important;
  padding: 0px;
  padding-left: 12px;
}

/* footer .el-pagination{
  position: absolute;
  right: 50px;
  width: 620px;
  box-sizing: border-box;
} */
/* .BulkOrderbysea .el-form {
  margin-top: 20px;
  margin-left: 31px;
}
.BulkOrderbysea .el-form .el-input {
  width: 68%;
  height: 38px;
  line-height: 38px;
  background: #ffffff;
  border-color: #e7e7e7;
  border-radius: 5px;
}
.BulkOrderbysea .el-form .el-input--suffix {
  width: 100%;
}
.BulkOrderbysea .el-select {
  width: 68%;
}
.BulkOrderbysea .el-date-editor--daterange.el-input,
.BulkOrderbysea .el-date-editor--daterange.el-input__inner,
.BulkOrderbysea .el-date-editor--timerange.el-input,
.BulkOrderbysea .el-date-editor--timerange.el-input__inner {
  width: 68%;
}
.BulkOrderbysea .el-form-item,
.el-form-item--small.el-form-item {
  width: 33%;
  display: inline-block;
}
.BulkOrderbysea .el-button--primary {
  width: 102px;
  height: 36px;
  padding: 0;
  border-radius: 5px;
  border: none;
} */
.BulkOrderbysea .el-tabs__header {
  margin: 0px 30px 15px;
}
.BulkOrderbysea .el-tabs__nav-wrap::after {
  background: none;
}
.BulkOrderbysea >>> .el-table td,
.BulkOrderbysea >>> .el-table th {
  padding: 6px 0;
  text-align: center;
}
.BulkOrderbysea .el-tabs__item.is-active {
  color: #343434;
}
.BulkOrderbysea .el-tabs__item {
  color: #9a9a9a;
}
.BulkOrderbysea .el-table__body-wrapper {
  height: 530px !important;
}
/* table 滚动条 */
.BulkOrderbysea .el-table__body-wrapper::-webkit-scrollbar {
  width: 3px;
}
.BulkOrderbysea .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}
.BulkOrderbysea .el-table__body-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter/FBAheader/FBAheader.vue